import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import PrivateRoute from 'components/routes/Private'
import AllGlobalRolesRoute from 'components/routes/AllGlobalRoles'
import AnyGlobalRolesRoute from 'components/routes/AnyGlobalRoles'
import NoGlobalRolesRoute from 'components/routes/NoGlobalRoles'

import { externalMode } from 'config'

import {
  GLOBAL_ROLES,
  ROUTE_ROLES,
} from 'containers/Role/constants'

// Admin Pages
import AdminPartnerSitePage from 'containers/Admin/PartnerSite/PartnerSite/index'
import AdminProductPage from 'containers/Admin/Product/Product/index'
import AdminUserPage from 'containers/Admin/User/User/index'
import AdminClientPage from 'containers/Admin/Client/Client/index'
import AdminPartsLibraryPage from 'containers/Admin/PartsLibrary/index'


// User Page
import UserProfile from 'containers/User/ProfilePage/index'

// Project Creation
import ProjectElasticSearch from 'containers/Project/ElasticSearch/index'
import ProjectSearch from 'containers/Project/Search/index'

import ProjectRoutes from 'containers/Project/routes'
import ProductRoutes from 'containers/Product/routes'
import ReportRoutes from 'containers/Report/routes'
import ManageRoutes from 'containers/Manage/routes'
import Email from 'containers/Report/Email'


import MyProjects from 'containers/MyProjects/index'

const AppRoutes = props => {
  return (
    <Switch>
      <NoGlobalRolesRoute exact path='/profile' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={UserProfile}/>
      <NoGlobalRolesRoute exact path='/myprojects' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={MyProjects} />
      <AllGlobalRolesRoute exact path='/admin/products' roles={[GLOBAL_ROLES.ADMIN_ACCESS]} component={AdminProductPage}/>
      <AllGlobalRolesRoute exact path='/admin/sites' roles={[GLOBAL_ROLES.ADMIN_ACCESS]} component={AdminPartnerSitePage}/>
      <AllGlobalRolesRoute exact path='/admin/users' roles={[GLOBAL_ROLES.ADMIN_ACCESS]} component={AdminUserPage}/>
      <AllGlobalRolesRoute exact path='/admin/clients' roles={[GLOBAL_ROLES.ADMIN_ACCESS]} component={AdminClientPage}/>
      <AnyGlobalRolesRoute exact path='/admin/parts_library' roles={[GLOBAL_ROLES.ADMIN_ACCESS, ROUTE_ROLES.DATA_MANAGER]} component={AdminPartsLibraryPage}/>
      <AnyGlobalRolesRoute path='/product' roles={[GLOBAL_ROLES.ADMIN_ACCESS, ROUTE_ROLES.DATA_MANAGER]} component={ProductRoutes}/>
      <NoGlobalRolesRoute path='/report' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={ReportRoutes}/>
      <NoGlobalRolesRoute path='/manage' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={ManageRoutes}/>
      
      <PrivateRoute path='/project' component={ProjectRoutes}/>
      <NoGlobalRolesRoute exact path='/' roles={[GLOBAL_ROLES.CLIENT_ACCESS]} component={ProjectElasticSearch} redirectTo='project/list' />
      <NoGlobalRolesRoute exact path='/email' roles={[GLOBAL_ROLES.ADMIN_ACESS, GLOBAL_ROLES.CLIENT_ACCESS]} component={Email} />

    </Switch>
  )
}

export default AppRoutes
